import React from 'react';
import { Spin, Empty, Alert, Button } from 'antd';
import './page.css';

/**
 * Loading / empty / error as three distinct renders sharing one gutter. Error offers a retry when
 * `onRetry` is given; empty can carry a next-action via `action`.
 */
const PageState = ({ status, message, onRetry, action }) => {
  if (status === 'loading') {
    return (
      <div className="pl-page-state" data-testid="page-state-loading">
        <Spin />
        {message ? <span>{message}</span> : null}
      </div>
    );
  }
  if (status === 'error') {
    return (
      <div className="pl-page-state" data-testid="page-state-error">
        <Alert
          type="error"
          showIcon
          message={message || 'Something went wrong.'}
          action={onRetry ? <Button size="small" onClick={onRetry}>Retry</Button> : undefined}
        />
      </div>
    );
  }
  return (
    <div className="pl-page-state" data-testid="page-state-empty">
      <Empty description={message || 'Nothing to show yet.'}>{action || null}</Empty>
    </div>
  );
};

export default PageState;
